import styled from 'styled-components';

const Subtitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-size: 14px;
  font-weight: normal;
  align-self: center;
  padding-top: 3%;
  line-height: 20px;
  width: 100%;
`;

export default Subtitle;
